<div class="lokos-input">
    @if (label) {
        <mat-label>
            {{ label | translate }}
            <span class="required">{{ required ? '*' : '' }}</span>
        </mat-label>
    }
    <div class="lokos-text-area">
        <textarea
            finNoScriptTag
            [placeholder]="placeholder | translate"
            [value]="value"
            [formControl]="control"
            [readonly]="readonly"
            [required]="required"
            [attr.disabled]="disabled"
            (blur)="afterBlur.emit($event)"
            (focus)="afterFocus.emit($event)"
            (input)="afterInput.emit($event)"
            [rows]="rows"
            [maxlength]="maxlength"
        ></textarea>
        @if (iconPosition === iconPositions.RIGHT) {
            <img [src]="iconPath" alt="icon" matSuffix />
        }
        @if (iconPosition === iconPositions.LEFT) {
            <img [src]="iconPath" alt="icon" matPrefix />
        }
    </div>
    @if (maxlength) {
        <p>{{ control.value?.length ?? 0 }} / {{ maxlength }}</p>
    }
    @if (control.invalid && (control.dirty || control.touched)) {
        <mat-error>{{ getErrorMessage() | translate }}</mat-error>
    }
</div>
